define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isSuccess = exports.isError = void 0;
    const isError = (status) => status && status.error !== null;
    exports.isError = isError;
    const isSuccess = (status) => status && status.success !== null && status.success.length > 0;
    exports.isSuccess = isSuccess;
});
//# sourceMappingURL=validator.js.map